// label-wobble.js
document.addEventListener('DOMContentLoaded', () => {
  const amplitudeRangeDeg      = [0.05, 0.25];
  const frequencyRangeHz       = [0.5, 1];
  const amplitudeYRangePx      = [0.1, 0.5];
  const frequencyYRangeHz      = [0.5, 1.3];
  const intervalRangeSec       = [5, 10];
  const ampTransitionDuration  = 2000;
  const ampYTransitionDuration = 2000;

  const boostDurationMs    = 600;
  const boostAmpFactor     = 1.1;
  const boostFreqFactor    = 1;    // без изменения частоты
  const boostTransitionMs  = 800;

  function rand(range) {
    const [min, max] = range;
    return min + Math.random() * (max - min);
  }

  // Инициализируем все .choosebutton, кроме тех, что отмечены .no-wobble
  const buttons = Array.from(
    document.querySelectorAll('.choosebutton:not(.no-wobble)')
  );
  if (!buttons.length) return;

  const items = buttons.map(el => {
    const computed = getComputedStyle(el).transform;
    const origTransform = computed === 'none' ? '' : computed;
    const now = performance.now();
    return {
      el,
      origTransform,

      baseAmplitude:  rand(amplitudeRangeDeg),
      frequency:      rand(frequencyRangeHz),
      phase:          Math.random() * 2 * Math.PI,
      oldBaseAmp:     0,
      targetBaseAmp:  0,
      ampStart:       0,
      transitioningAmp:  false,
      lastRnd:        now,
      nextRnd:        rand(intervalRangeSec) * 1000,

      baseAmplitudeY: rand(amplitudeYRangePx),
      frequencyY:     rand(frequencyYRangeHz),
      phaseY:         Math.random() * 2 * Math.PI,
      oldBaseAmpY:    0,
      targetBaseAmpY: 0,
      ampYStart:      0,
      transitioningAmpY: false,
      lastRndY:       now,
      nextRndY:       rand(intervalRangeSec) * 1000,

      boostPhase:          'idle',
      boostTransitionStart: 0,
      boostPeakUntil:       0,
      boostOldAmpFactor:    1,
      boostTargetAmpFactor: 1,
      boostOldFreqFactor:   1,
      boostTargetFreqFactor:1,
    };
  });

  function triggerBoost(item, ts) {
    if (item.boostPhase === 'up' || item.boostPhase === 'active') return;
    item.boostPhase = 'up';
    item.boostTransitionStart = ts;
    item.boostOldAmpFactor    = getCurrentBoostAmp(item, ts);
    item.boostTargetAmpFactor = boostAmpFactor;
    item.boostOldFreqFactor   = getCurrentBoostFreq(item, ts);
    item.boostTargetFreqFactor= boostFreqFactor;
    item.boostPeakUntil       = ts + boostDurationMs;
  }

  function getCurrentBoostAmp(item, ts) {
    if (item.boostPhase === 'up') {
      const prog = (ts - item.boostTransitionStart) / boostTransitionMs;
      return prog < 1
        ? item.boostOldAmpFactor + (item.boostTargetAmpFactor - item.boostOldAmpFactor) * prog
        : item.boostTargetAmpFactor;
    }
    if (item.boostPhase === 'active') {
      return boostAmpFactor;
    }
    if (item.boostPhase === 'down') {
      const prog = (ts - item.boostTransitionStart) / boostTransitionMs;
      return prog < 1
        ? item.boostOldAmpFactor + (1 - item.boostOldAmpFactor) * prog
        : 1;
    }
    return 1;
  }

  function getCurrentBoostFreq(item, ts) {
    if (item.boostPhase === 'up') {
      const prog = (ts - item.boostTransitionStart) / boostTransitionMs;
      return prog < 1
        ? item.boostOldFreqFactor + (item.boostTargetFreqFactor - item.boostOldFreqFactor) * prog
        : item.boostTargetFreqFactor;
    }
    if (item.boostPhase === 'active') {
      return boostFreqFactor;
    }
    if (item.boostPhase === 'down') {
      const prog = (ts - item.boostTransitionStart) / boostTransitionMs;
      return prog < 1
        ? item.boostOldFreqFactor + (1 - item.boostOldFreqFactor) * prog
        : 1;
    }
    return 1;
  }

  items.forEach(item => {
    const { el } = item;
    el.addEventListener('mouseenter', () => {
      triggerBoost(item, performance.now());
    }, { passive: true });
    el.addEventListener('click', () => {
      triggerBoost(item, performance.now());
    }, { passive: true });
    el.addEventListener('conversationStart', () => {
      triggerBoost(item, performance.now());
    });
  });

  function update(ts) {
    const t = ts / 1000;

    items.forEach(item => {
      const { el } = item;
      if (!el.isConnected) return;

      // обновление амплитуды X
      if (item.transitioningAmp) {
        const prog = (ts - item.ampStart) / ampTransitionDuration;
        if (prog < 1) {
          item.baseAmplitude =
            item.oldBaseAmp + (item.targetBaseAmp - item.oldBaseAmp) * prog;
        } else {
          item.baseAmplitude = item.targetBaseAmp;
          item.transitioningAmp = false;
        }
      }
      if (!item.transitioningAmp && ts - item.lastRnd > item.nextRnd) {
        item.boostPhase = 'idle';
        item.oldBaseAmp    = item.baseAmplitude;
        item.targetBaseAmp = rand(amplitudeRangeDeg);
        item.ampStart      = ts;
        item.transitioningAmp = true;
        item.frequency     = rand(frequencyRangeHz);
        item.phase         = Math.random() * 2 * Math.PI;
        item.lastRnd       = ts;
        item.nextRnd       = rand(intervalRangeSec) * 1000;
      }

      // обновление амплитуды Y
      if (item.transitioningAmpY) {
        const progY = (ts - item.ampYStart) / ampYTransitionDuration;
        if (progY < 1) {
          item.baseAmplitudeY =
            item.oldBaseAmpY + (item.targetBaseAmpY - item.oldBaseAmpY) * progY;
        } else {
          item.baseAmplitudeY = item.targetBaseAmpY;
          item.transitioningAmpY = false;
        }
      }
      if (!item.transitioningAmpY && ts - item.lastRndY > item.nextRndY) {
        item.boostPhase = 'idle';
        item.oldBaseAmpY    = item.baseAmplitudeY;
        item.targetBaseAmpY = rand(amplitudeYRangePx);
        item.ampYStart      = ts;
        item.transitioningAmpY = true;
        item.frequencyY     = rand(frequencyYRangeHz);
        item.phaseY         = Math.random() * 2 * Math.PI;
        item.lastRndY       = ts;
        item.nextRndY       = rand(intervalRangeSec) * 1000;
      }

      // управление фазой буста
      if (item.boostPhase === 'up') {
        const progUp = (ts - item.boostTransitionStart) / boostTransitionMs;
        if (progUp >= 1) item.boostPhase = 'active';
      }
      if (item.boostPhase === 'active' && ts >= item.boostPeakUntil) {
        item.boostPhase = 'down';
        item.boostTransitionStart = ts;
        item.boostOldAmpFactor    = boostAmpFactor;
        item.boostOldFreqFactor   = boostFreqFactor;
      }
      if (item.boostPhase === 'down') {
        const progDown = (ts - item.boostTransitionStart) / boostTransitionMs;
        if (progDown >= 1) item.boostPhase = 'idle';
      }

      const currBoostAmp  = getCurrentBoostAmp(item, ts);
      const currBoostFreq = getCurrentBoostFreq(item, ts);

      const freq   = item.frequency  * currBoostFreq;
      const freqY  = item.frequencyY * currBoostFreq;
      const amp    = item.baseAmplitude  * currBoostAmp;
      const ampY   = item.baseAmplitudeY * currBoostAmp;

      const angle = amp * Math.sin(2 * Math.PI * freq  * t + item.phase);
      const yOff  = ampY * Math.sin(2 * Math.PI * freqY * t + item.phaseY);

      const wobbleTransform = `rotate(${angle}deg) translateY(${yOff}px)`;
      el.style.transform = item.origTransform
        ? `${item.origTransform} ${wobbleTransform}`
        : wobbleTransform;
    });

    requestAnimationFrame(update);
  }

  requestAnimationFrame(update);
});
